import React from 'react';

export const CustomTitleField = ({title, required}) => {
    return (
        <legend id="root_title">
            {title}{required ? <span className="text-danger">*</span> : null}
        </legend>
    );
  };